import { useKeyboardControls } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { RigidBody, useRapier } from "@react-three/rapier";
import { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import useGame from "./stores/useGame";


export default function Player() {
    const [subscribeKeys, getKeys] = useKeyboardControls()
    const body = useRef()
    const {rapier, world} = useRapier()
    const [smoothedCameraPosition] = useState(new THREE.Vector3(0,10,30))
    const [smoothedCameraTarget] = useState(new THREE.Vector3())
    const start = useGame((state) => state.start)
    const end = useGame((state) => state.end)
    const restart = useGame((state) => state.restart)
    const blocksCount = useGame((state) => state.blocksCount)
    const jump = () => {
        if (!body.current) return

        const origin = body.current.translation()
        origin.y -= 0.31 // just below the sphere

        const direction = { x: 0, y: -1, z: 0 }
        const ray = new rapier.Ray(origin, direction)

        const hit = world.castRay(
            ray,
            0.15,   // ray length
            true    // solid
        )

        if (hit) {
            // We are on the ground
            body.current.applyImpulse({ x: 0, y: 0.6, z: 0 }, true)
        }
    }

    const reset = ()=>{
        // Reset player position
        body.current.setTranslation({x:0, y:0.3, z:16}, true)
        body.current.setLinvel({x:0, y:0, z:0}, true)
        body.current.setAngvel({x:0, y:0, z:0}, true)
    }

    useEffect(() => {
        const unsubscribePhase = useGame.subscribe(
            (state)=>state.phase,
            (value)=>{
                if(value=="ready"){
                    reset()
                    // console.log("phased changed to ",value)
                }
            }
        )
        const unsubscribeJump = subscribeKeys(
            (state) => state.jump,
            
            (value) => {
                if(value){
                    jump()
                }
                
            }
        )
        const unsubscribeAny = subscribeKeys(
            ()=>{
                    start()
            }
        )
        return ()=>{
            unsubscribeJump()
            unsubscribeAny()
            unsubscribePhase()
        }
        

    }, [subscribeKeys])
    useFrame((state, delta) => {
        // Player movement logic will go here
        const {forward, backward, left, right, jump} = getKeys()
        
        // console.log({forward, backward, left, right, jump})
        const impulse = {x:0, y:0, z:0}
        const torque = {x:0, y:0, z:0}
        const impulseStrength = 0.5 * delta
        const torqueStrength = 0.15 * delta
        const speed = 1
        if(forward){
            impulse.z -= impulseStrength
            torque.x -= torqueStrength
        }
        if(backward){
            impulse.z += impulseStrength
            torque.x += torqueStrength
        }
        if(left){
            impulse.x -= impulseStrength
            torque.z += torqueStrength
        }
        if(right){
            impulse.x += impulseStrength
            torque.z -= torqueStrength
        }
        
        body.current.applyImpulse(impulse)
        body.current.applyTorqueImpulse(torque)

        //Camera follow player
        const bodyPosition = body.current.translation()
        const cameraPosition = new THREE.Vector3()
        cameraPosition.copy(bodyPosition)
        cameraPosition.z += 3
        cameraPosition.y += 0.65
        const cameraTarget = new THREE.Vector3()
        cameraTarget.copy(bodyPosition)
        cameraTarget.y += 0.25
        
        smoothedCameraPosition.lerp(cameraPosition, 5 * delta)
        smoothedCameraTarget.lerp(cameraTarget, 5 * delta)

        state.camera.position.copy(smoothedCameraPosition)
        state.camera.lookAt(smoothedCameraTarget)
        
        //Phases
        if(bodyPosition.z < -(blocksCount * 2)+3.5){
            end()
            // console.log("weaend")
        }
        
        if(bodyPosition.y < -4) {
            
            restart()
            // console.log("reset")
        }
        

        // Reset player if it falls below certain Y level
    })
    return (
        <RigidBody linearDamping={0.5} angularDamping={0.5} ref={body} colliders="ball" mass={1} restitution={0.2} friction={1} position={[0,0.3,16]}>
            <mesh castShadow >
                <icosahedronGeometry args={[0.3,1]} />
                <meshStandardMaterial flatShading color="mediumpurple" />
            </mesh>
        </RigidBody>
    )
}